import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_silky_purple/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-111d12f00f.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-a537b43493.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-c9153f1eb6.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-1371a4af93.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-4274d6a843.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-77415723c5.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-62fad06266.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-d3fa7039ec.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-5961e25799.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-d2783232bc.png'; };
